<template>
  <div class="department-overview-view" v-if="rolePower">
    <title-bar class="title-bar-view" :title="'科室总览'" :showAll="false"></title-bar>
    <GrowthOverview :initData="journeyData"></GrowthOverview>
    <RadarChartAIFV :initData="radarChartData" :totalData="totalData"></RadarChartAIFV>
  </div>
</template>

<script>
import { getGrowthOverview, getDepDevelop } from '@/api/departmentOverview'
import TitleBar from './TitleBar.vue'
import GrowthOverview from './GrowthOverview.vue'
import RadarChartAIFV from './RadarChartAIFV.vue'
import { BOOL_SENIOR } from '@/utils/configRoles'
import { checkObject } from '@/utils/util'
export default {
  name: 'DepartmentOverview',
  components: {
    TitleBar,
    GrowthOverview,
    RadarChartAIFV
  },
  data() {
    return {
      // 成长概览默认数据
      journeyData: [
        {
          journeyName: '超声视界之旅',
          journeydescription: 'CDQI一级术者申报要求，近12个月房颤手术量：200',
          unFoldStatus: false,
          doctors: []
        },
        {
          journeyName: '持续性房颤菁英之旅',
          journeydescription: 'CDQI二级术者申报要求，近12个月房颤：100',
          unFoldStatus: false,
          doctors: []
        },
        {
          journeyName: '阵发性房颤进阶之旅',
          journeydescription: 'CDQI三级术者申报要求，近12个月房颤：100',
          unFoldStatus: false,
          doctors: []
        },
        {
          journeyName: '电生理成长之旅',
          journeydescription: '成长所需，推荐手术量：30',
          unFoldStatus: false,
          doctors: []
        }
      ],
      // 雷达图默认数据
      radarChartData: {
        currentAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        prevAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        countryAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        provinceAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        }
      },
      // 成长总览-数据统计
      totalData: {
        replay: '0',
        practice: '0',
        learnTime: '0',
        score: '0',
        percent: '0'
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    // 是否为大主任
    rolePower() {
      return BOOL_SENIOR
    }
  },
  methods: {
    getGrowthData() {
      let params = {
        pageNum: 1,
        pageSize: 10,
        multiCode: this.userInfo.multiCode
        // multiCode: 'MULD10000347973'
      }
      getGrowthOverview(params).then(res => {
        console.log('getGrowthData res', res)
        if (res && res.data) {
          if (res.data.list.length > 0) {
            let list = JSON.parse(JSON.stringify(res.data.list))
            let arr1 = list.filter(item => {
              return item.currentJourneyName === '超声视界之旅'
            })
            let arr2 = list.filter(item => {
              return item.currentJourneyName === '持续性房颤菁英之旅'
            })
            let arr3 = list.filter(item => {
              return item.currentJourneyName === '阵发性房颤进阶之旅'
            })
            let arr4 = list.filter(item => {
              return item.currentJourneyName === '电生理成长之旅'
            })
            // 有数据时展开,没有数据时收起
            this.journeyData[0].unFoldStatus = arr1.length > 0
            this.journeyData[1].unFoldStatus = arr2.length > 0
            this.journeyData[2].unFoldStatus = arr3.length > 0
            this.journeyData[3].unFoldStatus = arr4.length > 0
            // 医生分组
            this.journeyData[0].doctors = arr1
            this.journeyData[1].doctors = arr2
            this.journeyData[2].doctors = arr3
            this.journeyData[3].doctors = arr4
            console.log('🚀 ~ file: director-home.vue:2003 ~ .then ~ this.journeyData', this.journeyData)
          }
        }
      })
    },
    getDepData() {
      getDepDevelop({
        pageNum: 1,
        pageSize: 10,
        multiCode: this.userInfo.multiCode
        // multiCode: 'MULD100127123'
      })
        .then(res => {
          console.log('getDepData res', res)
          if (res && res.data) {
            if (checkObject(res.data)) {
              let rData = JSON.parse(JSON.stringify(res.data))
              // 数据统计
              this.totalData.replay = Number(rData.deptCaseReviewCnt).toFixed(0) || 0
              this.totalData.practice = Number(rData.dtptCasePracticeCnt).toFixed(0) || 0
              this.totalData.learnTime = Number(rData.deptLearningDuration).toFixed(1) || 0
              this.totalData.score = Number(rData.deptAifv).toFixed(1) || 0
              this.totalData.percent = Number(rData.deptThanPercent).toFixed(2) || 0
              // currentAifv
              this.radarChartData.currentAifv.aifv1 = Number(rData.aifv1) || 0
              this.radarChartData.currentAifv.aifv2 = Number(rData.aifv2) || 0
              this.radarChartData.currentAifv.aifv3 = Number(rData.aifv3) || 0
              this.radarChartData.currentAifv.aifv4 = Number(rData.aifv4) || 0
              this.radarChartData.currentAifv.aifv5 = Number(rData.aifv5) || 0
              this.radarChartData.currentAifv.aifv6 = Number(rData.aifv6) || 0
              // prevAifv
              this.radarChartData.prevAifv.aifv1 = Number(rData.aifv1L) || 0
              this.radarChartData.prevAifv.aifv2 = Number(rData.aifv2L) || 0
              this.radarChartData.prevAifv.aifv3 = Number(rData.aifv3L) || 0
              this.radarChartData.prevAifv.aifv4 = Number(rData.aifv4L) || 0
              this.radarChartData.prevAifv.aifv5 = Number(rData.aifv5L) || 0
              this.radarChartData.prevAifv.aifv6 = Number(rData.aifv6L) || 0
              // provinceAvgAifv
              this.radarChartData.provinceAvgAifv.aifv1 = Number(rData.aifv1LP) || 0
              this.radarChartData.provinceAvgAifv.aifv2 = Number(rData.aifv2LP) || 0
              this.radarChartData.provinceAvgAifv.aifv3 = Number(rData.aifv3LP) || 0
              this.radarChartData.provinceAvgAifv.aifv4 = Number(rData.aifv4LP) || 0
              this.radarChartData.provinceAvgAifv.aifv5 = Number(rData.aifv5LP) || 0
              this.radarChartData.provinceAvgAifv.aifv6 = Number(rData.aifv6LP) || 0
            }
          }
        })
        .catch(err => {
          console.log('getDepData err', err)
        })
    }
  },
  mounted() {
    if (this.rolePower) {
      this.getGrowthData()
      this.getDepData()
    }
  }
}
</script>

<style lang="less" scoped>
.department-overview-view {
  margin-top: 16px;
  padding: 0 12px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/DepartmentOverview.vue